<template>
<div class="nofound_layout">
	404
</div>
</template>

<script>
export default {

  name: 'NotFound',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
	.nofound_layout{
		width: 100%;
		height: 100vh;
		background-color: #352f8d;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-size: 60px;
		font-weight: 700;
		flex-direction: column;
	}
</style>